module.exports = ".mat-form-field{\n display: block;   \n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admintrademaster/edit-admin-trade-master/edit-admin-trade-master.component.css
// module id = ./src/app/admintrademaster/edit-admin-trade-master/edit-admin-trade-master.component.css
// module chunks = main